import React, { Fragment } from 'react'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'
import { commonActions } from 'srcReact/components'
import { subscriptionActions } from 'srcReact/SubscriptionPage'

const PricingErrorMessage = (props) => {
  const { t, organizationId, selectedPlan } = props

  const handleClosePopin = () => {
    const { closePopin } = props

    closePopin()
  }

  const handleCancelPendingPlanUpdate = () => {
    const { cancelPendingPlanUpdate } = props

    cancelPendingPlanUpdate(organizationId)
  }

  return (
    <Fragment>
      <p className='popin-content--text' dangerouslySetInnerHTML={{ __html: selectedPlan.unavailable_message }} />
      <div className='popin-content--controllers with-link'>
        {selectedPlan.with_cancel_button === 1 ? (
          <button type='button' className='button is-primary popin-content--long-button' onClick={handleCancelPendingPlanUpdate}>
            {selectedPlan.cancel_button_message}
          </button>
        ) : (
          <button type='button' className='button is-primary' onClick={handleClosePopin}>
            {t('billing.popin.pricingErrorMessage.btnPrimary')}
          </button>
        )}
      </div>
    </Fragment>
  )
}

const actionCreators = {
  closePopin: commonActions.closePopin,
  cancelPendingPlanUpdate: subscriptionActions.cancelPendingPlanUpdate,
}

const ExtendedComponent = withTranslation('common')(PricingErrorMessage)
const connectedPricingErrorMessage = connect(null, actionCreators)(ExtendedComponent)

export { connectedPricingErrorMessage as PricingErrorMessage }
